import * as React from 'react';
import { observer } from 'mobx-react';
import { style } from 'typestyle';
import { px } from 'csx';
import { zCookieNotification } from '../theme/z';
import { centerCenter, flexRoot } from 'csstips';
import { colorWhite, rebrand } from '../theme/color';
import { spacing } from '../theme/spacing';
import { borderRadius } from '../theme/border';
import { shadowElevation6 } from '../theme/shadow';
import { InfoCircle } from './project-happy/atoms/icons/InfoCircle';
import { Button } from './project-happy/atoms/button/Button';
import { ButtonProminence, ButtonSize } from './project-happy/atoms/button/buttonStyles';
import { prismicRichTextToHtml } from './project-happy/utilities/prismic';
import { fontstackDefault } from './project-happy/config';

export interface AppCookieNotificationModel {
  show: boolean;
  title: string;
  content: any;
}

export interface AppCookieNotificationProps {
  model: AppCookieNotificationModel;
  onClose(): void;
}

const styles = {
  container: style({
    ...centerCenter,
    zIndex: zCookieNotification,
    position: 'fixed',
    bottom: spacing.DEFAULT,
    left: spacing.DEFAULT,
    right: spacing.DEFAULT,
  }),
  alert: style(flexRoot, {
    maxWidth: px(640),
    backgroundColor: colorWhite.toString(),
    borderRadius: borderRadius.MEDIUM,
    padding: spacing.DEFAULT,
    fontSize: px(12),
    color: rebrand.contrast[40].toString(),
    ...shadowElevation6,
  }),
  title: style({
    fontFamily: fontstackDefault,
    margin: 0,
    fontSize: px(12),
    fontWeight: 700,
    color: rebrand.contrast[50].toString(),
    lineHeight: 1.5,
  }),
  infoIcon: style({
    flexShrink: 0,
  }),
  content: style({
    marginLeft: spacing.XSMALL,
    $nest: {
      '& p': {
        margin: 0,
      },
      '& a': {
        color: rebrand.contrast[40].toString(),
        textDecoration: 'underline',
      },
    },
  }),
  btnWrapper: style({
    marginLeft: spacing.DEFAULT,
    flexShrink: 0,
    alignSelf: 'flex-end',
  }),
  closeBtn: style({
    padding: `${px(4)} ${px(18)}`,
    minHeight: px(24),
  }),
};

@observer
export class AppCookieNotification extends React.Component<AppCookieNotificationProps, any> {
  render() {
    const { model, onClose } = this.props;

    if (!model.show) return null;

    return (
      <div className={styles.container}>
        <div className={styles.alert}>
          <InfoCircle size={16} color={rebrand.contrast[40].toHexString()} className={styles.infoIcon} />
          <div className={styles.content}>
            <h5 className={styles.title}>{model.title}</h5>
            <div dangerouslySetInnerHTML={{ __html: prismicRichTextToHtml(model.content) }} />
          </div>
          <div className={styles.btnWrapper}>
            <Button
              prominence={ButtonProminence.SECONDARY}
              size={ButtonSize.SMALL}
              onClick={onClose}
              className={styles.closeBtn}
              data-action="close"
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
